import { GeoJsonEditMode } from "@nebula.gl/edit-modes";

export class DrawStationMode extends GeoJsonEditMode {
  handleClick(event: any, props: any) {
    // Do nothing - let the onLayerClick handle the modal opening
    // This prevents the automatic point creation from DrawPointMode
  }

  handlePointerMove({ picks }: { picks: any[] }, { onUpdateCursor }: any) {
    // Update cursor to indicate clickable area
    onUpdateCursor("crosshair");
  }
} 